import request from '@/router/axios'

const API = '/api/twin/emergency/env-monitor'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchPowerRoomMonitor(params = {}) {
  return request({
    url: API,
    method: 'get',
    params
  }).then(unwrap)
}
